import './signup.scss';
import React, {Component} from 'react';

class Signup extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                <div>Hi Sing up</div>
            </>

        );
    }
}

export default Signup;